import _styled from "../../../../_snowpack/pkg/styled-components.js";
import React, { useEffect, useState } from '../../../../_snowpack/pkg/react.js';
import styled from '../../../../_snowpack/pkg/styled-components.js';
import isEmpty from '../../../../_snowpack/pkg/lodash/isEmpty.js';
import * as Dialog from '../../../../_snowpack/pkg/@crystallize/react-dialog.js';
import { useHistory } from '../../../../_snowpack/pkg/react-router.js';
import { ADD_CREDIT_CARD, CHOOSE_THIS_PLAN, YOUR_CURRENT_PLAN } from './create-crystallize-subscription/constants.js';
import { cancelSubscriptionContract, createSubscriptionContractInCrystallize, getActiveSubscriptionContractId, getActiveSubscriptionPlanName, getSubscriptionContracts } from './create-crystallize-subscription/utils.js';
import { Content } from '../../../modules/layout/main/index.js';
import { getSingleCustomer } from '../billing/billing-payments/utils.js';
import { PricingPlan } from './plan.js';
import { STRIPE_PAYMENT_METHOD_ID } from '../billing/billing-payments/constants.js';
import { SubscriptionChange } from './create-crystallize-subscription/interfaces.js';
import { SubscriptionServiceError } from './SubscriptionServiceError.js';
import { useTenant } from '../../../hooks/index.js';
import DocumentTitle from '../../../modules/document-title/index.js';
import Loading from '../../../modules/loading/index.js';
import { Wrapper } from '../styles.js';
import { PlanContainer } from './styles.js';
import { PlansData } from './plan-data.js';

var _StyledContent = styled(Content).withConfig({
  displayName: "plans___StyledContent",
  componentId: "t71wg1-0"
})(["background:#f3f4f6;"]);

const Plans = () => {
  const {
    tenant
  } = useTenant();
  const history = useHistory();
  const [currentPlanName, setCurrentPlanName] = useState('Particle');
  const [status, setStatus] = useState('Fetching Plan');
  const [cancellingPlan, setCancellingPlan] = useState(false);
  const [activeProdSubId, setActiveProdSubId] = useState('');
  const [paymentMethodExist, setPaymentMethodExist] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    async function getThisCustomer() {
      setLoading(true);
      const customer = await getSingleCustomer(tenant.identifier).catch(err => setError(err.message));
      if (customer instanceof Error) setError(customer.message);else setCustomerData(customer);
      setLoading(false);
    }

    getThisCustomer();
  }, [tenant.identifier]);
  /** If customer exist in Crystallize, get paymentMethod and the active product subscription id **/

  useEffect(() => {
    async function getActiveSubscription() {
      if (!isEmpty(customerData)) {
        var _customerData$meta;

        const paymentMethod = customerData === null || customerData === void 0 ? void 0 : (_customerData$meta = customerData.meta) === null || _customerData$meta === void 0 ? void 0 : _customerData$meta.filter(m => m.key === STRIPE_PAYMENT_METHOD_ID)[0];
        if (paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.value) setPaymentMethodExist(true);
        const response = await getSubscriptionContracts(tenant.identifier).catch(err => setError(err.message));
        if (response instanceof Error) setError(response.message);else {
          setActiveProdSubId(getActiveSubscriptionContractId(response));
          setCurrentPlanName(getActiveSubscriptionPlanName(response));
          setStatus('Plan fetched');
          setLoading(false);
        }
      } else setStatus('Plan fetched');
    }

    getActiveSubscription();
  }, [customerData, tenant.identifier]);

  const isThisCurrentPlan = pricingPlan => pricingPlan.name.toLowerCase() === currentPlanName.toLowerCase();

  const getButtonLabel = pricingPlan => {
    if (pricingPlan.name.toLowerCase() !== currentPlanName.toLowerCase()) return `${CHOOSE_THIS_PLAN}`;else return `${ADD_CREDIT_CARD}`;
  };

  const onChangePlanOnly = async (newPlan, subscriptionOp) => {
    const deactivateNow = subscriptionOp === SubscriptionChange.UpgradeParticleToAtomWithoutPayment;
    const body = deactivateNow ? `Do you want to proceed?` : `Your atom plan will remain active until the end of the month after which you will automatically move to Particle plan. Do you want to proceed?`;
    const title = deactivateNow ? `You are upgrading your subscription plan to ${newPlan}.` : `You are changing your subscription plan to ${newPlan}.`;
    const answer = await Dialog.showConfirm({
      title: `${title}`,
      body: `${body}`,
      buttons: {
        ok: `Yes, change plan`,
        cancel: `Stay on current plan`
      }
    });

    if (answer === 'cancel') {
      return;
    } else {
      setCancellingPlan(true);
      const cancelled = await cancelSubscriptionContract(activeProdSubId, deactivateNow).catch(err => {
        setCancellingPlan(false);
        setError(err.message);
      });

      if (cancelled instanceof Error) {
        setError(cancelled.message);
      }

      if (cancelled !== null && cancelled !== void 0 && cancelled.id) {
        const res = await createSubscriptionContractInCrystallize(tenant.identifier, newPlan).catch(err => {
          setCancellingPlan(false);
          setError(err.message);
        });

        if (res instanceof Error) {
          setError(res.message);
        }

        if (res !== null && res !== void 0 && res.id) {
          setCancellingPlan(false);
          history.push(`/`);
          history.push(`/settings/tenants/${tenant.identifier}/plans`);
        }
      }
    }
  };

  if (error) {
    return /*#__PURE__*/React.createElement(SubscriptionServiceError, {
      error: error
    });
  }

  if (loading || status === 'Fetching Plan' || cancellingPlan) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }

  return /*#__PURE__*/React.createElement(_StyledContent, null, /*#__PURE__*/React.createElement(DocumentTitle, {
    title: "Plans"
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MainContainer, null, /*#__PURE__*/React.createElement(PlanContainer, null, PlansData.map((plan, key) => {
    return /*#__PURE__*/React.createElement(PricingPlan, {
      key: key,
      pricingPlan: plan,
      activeProdSubId: activeProdSubId,
      paymentMethodExist: paymentMethodExist,
      disableButton: isThisCurrentPlan(plan) && activeProdSubId && paymentMethodExist || false,
      buttonLabel: isThisCurrentPlan(plan) && activeProdSubId && paymentMethodExist ? YOUR_CURRENT_PLAN : getButtonLabel(plan),
      onChangePlanOnly: onChangePlanOnly
    });
  })))));
};

export default Plans;
export const MainContainer = styled.div.withConfig({
  displayName: "plans__MainContainer",
  componentId: "t71wg1-1"
})(["grid-area:content;padding:100px 0;"]);
export const ERROR_FETCHING_PLAN = `Sorry, we couldn't get your plan information`;
export const ERROR_CANCELLING_SUBSCRIPTION = ` We could not cancel your existing subscription`;
export const ERROR_CREATING_NEW_SUBSCRIPTION = ` We couldn't activate your subscription. Please contact us at hello@crystallize.com`;